<template>
  <div>
    <div id="browserBar" class="text-center" v-if="upgrade">
      We have detected that your are using {{ browser.name }}, for the best experience please install Google Chrome <a href="https://www.google.com/chrome/">here</a>
    </div>
    <router-view/>
  </div>
</template>

<script>
  import {detect} from 'detect-browser'

  export default {
    name: 'App',
    data () {
      return {
        browser: null,
        upgrade: false
      }
    },
    mounted () {
      const browser = detect()
      if (browser) {
        this.browser = browser
        this.upgrade = ['chrome', 'crios', 'firefox', 'edge', 'safari', 'opera', 'ios'].indexOf(browser.name.toLowerCase()) === -1
      }
    },
    computed: {
      dashboard: function () {
        return this.$store.state.GET_DASHBOARD_RESPONSE
      },
      user: function () {
        return this.$store.state.GET_USER_RESPONSE
      },
      loginRsp () {
        let tokens = this.$store.state.POST_LOGIN_RESPONSE.authorities

        return tokens
      },
      isProfileCompleted: function () {
        return this.dashboard && this.dashboard.profileCompleted === true
      },
      isUnderAgeRestrictionsApplicable: function () {
        if (this.isUnderAge) {
          return this.user.parentConsented !== true
        }
        return false
      },
      isUnderAge: function () {
        return this.user && this.user.underage ? this.user.underAge === true : false
      }
    },

    watch: {
      // Handles profileCompete route on page refresh
      dashboard: function () {
        if (this.isProfileCompleted !== true || this.isUnderAgeRestrictionsApplicable === true) {
          this.$bus.$emit('disableSidebar')
          this.$router.push('/profile')
        }
      },
      user: function () {

      }
    }
  }
</script>

<style lang='scss'>

  @import './styles/main';

  body, html{
    padding: 0;
    margin: 0;
    height: 100%;
  }

  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all 0.5s 0.1s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(-30px);
    position: absolute;
    opacity: 0;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .tooltip { display: block !important; z-index: 10000; .tooltip-inner { background: black; color: white; border-radius: 16px; padding: 5px 10px 4px; } .tooltip-arrow { width: 0; height: 0; border-style: solid; position: absolute; margin: 5px; border-color: black; z-index: 1; } &[x-placement^="top"] { margin-bottom: 5px; .tooltip-arrow { border-width: 5px 5px 0 5px; border-left-color: transparent !important; border-right-color: transparent !important; border-bottom-color: transparent !important; bottom: -5px; left: calc(50% - 5px); margin-top: 0; margin-bottom: 0; } } &[x-placement^="bottom"] { margin-top: 5px; .tooltip-arrow { border-width: 0 5px 5px 5px; border-left-color: transparent !important; border-right-color: transparent !important; border-top-color: transparent !important; top: -5px; left: calc(50% - 5px); margin-top: 0; margin-bottom: 0; } } &[x-placement^="right"] { margin-left: 5px; .tooltip-arrow { border-width: 5px 5px 5px 0; border-left-color: transparent !important; border-top-color: transparent !important; border-bottom-color: transparent !important; left: -5px; top: calc(50% - 5px); margin-left: 0; margin-right: 0; } } &[x-placement^="left"] { margin-right: 5px; .tooltip-arrow { border-width: 5px 0 5px 5px; border-top-color: transparent !important; border-right-color: transparent !important; border-bottom-color: transparent !important; right: -5px; top: calc(50% - 5px); margin-left: 0; margin-right: 0; } } &[aria-hidden='true'] { visibility: hidden; opacity: 0; transition: opacity .15s, visibility .15s; } &[aria-hidden='false'] { visibility: visible; opacity: 1; transition: opacity .15s; } }

  #browserBar{
    background: yellow;
    padding: 10px 0;
    font-size:22px;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue